export enum GaContentTypeEnum {
  STRATEGY = "STRATEGY",
  CLICK_INSPIRE = "CLICK_INSPIRE",
}
